var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiv12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.28125,
    width: 46,
    height: 46,
    rx: 13,
    fill: "#06BA63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6991 25.6991L14.2891 24.2891L20.9891 17.5791L24.4891 21.0791L33.2891 12.2891L34.6991 13.6991L24.4891 23.9091L20.9891 20.4091L15.6991 25.6991Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9922 19H32.9922V14H27.9922V12H34.9922V19Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7111 26.2967L25.2969 27.7109L27.298 29.712L28.7122 28.2978L26.7111 26.2967Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9981 36.4528L25.5781 30.0428L28.9981 26.6328L35.4081 33.0428L31.9981 36.4528ZM28.3781 30.0028L31.9681 33.5928L32.5481 33.0028L28.9981 29.4528L28.3781 30.0028Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30C19.4177 30 17.871 29.5308 16.5555 28.6518C15.2399 27.7727 14.2145 26.5233 13.609 25.0615C13.0035 23.5997 12.845 21.9911 13.1537 20.4393C13.4624 18.8875 14.2243 17.462 15.3431 16.3432C16.462 15.2244 17.8874 14.4624 19.4393 14.1537C20.9911 13.845 22.5997 14.0035 24.0615 14.609C25.5233 15.2145 26.7727 16.2399 27.6518 17.5555C28.5308 18.871 29 20.4177 29 22C29 24.1217 28.1572 26.1566 26.6569 27.6569C25.1566 29.1572 23.1217 30 21 30ZM21 16C19.8133 16 18.6533 16.3519 17.6666 17.0112C16.6799 17.6705 15.9109 18.6076 15.4567 19.7039C15.0026 20.8003 14.8838 22.0067 15.1153 23.1706C15.3468 24.3344 15.9182 25.4035 16.7574 26.2426C17.5965 27.0818 18.6656 27.6532 19.8295 27.8847C20.9934 28.1162 22.1998 27.9974 23.2961 27.5433C24.3925 27.0892 25.3295 26.3201 25.9888 25.3334C26.6481 24.3467 27 23.1867 27 22C27 20.4087 26.3679 18.8826 25.2426 17.7574C24.1174 16.6322 22.5913 16 21 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv12);
export default __webpack_public_path__ + "static/media/div12.6e474292345e2739e58db354ca20ddb4.svg";
export { ForwardRef as ReactComponent };